export default "__VITE_PUBLIC_ASSET__c9019ee3__"